import '.i{background:transparent;}.ssr-plugin'
import '.j{border:none;}.ssr-plugin'
import '.k{cursor:pointer;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.l{gap:12px;}.ssr-plugin'
import '.m{border-radius:16px;}.ssr-plugin'
import '.n{padding:16px;}.ssr-plugin'
import '.o{margin-bottom:24px;}.ssr-plugin'
import '.p{color:white;}.ssr-plugin'
import '.q{margin-top:24px;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.r{background-color:#F00;}.ssr-plugin'
import '.s{padding:16px;}.ssr-plugin'
import '.t{height:40px;}.ssr-plugin'
import '.u{border-radius:12px;}.ssr-plugin'
import '.v{padding:8px 8px 8px 12px;}.ssr-plugin'
import '.w{font-size:15px;}.ssr-plugin'
import '.x{box-shadow:0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02);}.ssr-plugin'
import '.y{margin-top:8px;}.ssr-plugin'
import '.z{color:red;}.ssr-plugin'
import '.a0{margin-bottom:24px;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import '.a2{border-width:0px;}.ssr-plugin'
import '.a3{min-width:16px;}.ssr-plugin'
import '.a4{height:16px;}.ssr-plugin'
import '.a5{width:16px;}.ssr-plugin'
import '.a6{margin-right:8px;}.ssr-plugin'
import '.a7{position:relative;}.ssr-plugin'
import '.a8{appearance:none;}.ssr-plugin'
import '.a9{border-radius:1px;}.ssr-plugin'
import '.aa{user-select:none;}.ssr-plugin'
import { FC, useEffect } from 'react'
import { adjustColor, capitalize, useIsMobile } from '@based/ui'
import { Layout } from './Layout'
import { Navigation } from '../components/Navigation'
import { Text } from '../components/Text'
import { useTheme } from '../providers/useTheme'
import { useAppCtx } from '../providers/useAppCtx'
import { ErrorUserMessages } from '@/functions/payment/process-payment/errors'
import { RequestPaymentFunctionPayload } from '@/functions/payment/request-payment'
import {
  Payment,
  PaymentElement,
  usePayment,
} from '@based/payment-plugin/browser'
import { styled } from 'inlines'
import { useState } from 'react'
import { Button } from '../components/Button'
import { Icon } from '../components/Icon'
import { TermsModal } from '../components/TermsModal'
import { Link } from 'wouter'
import { Turnstile } from '../components/Turnstile'
import { rgbaToHex } from '../utils/rgbaToHex'
import { useQuery } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { useTranslations } from '../hooks/useTranslations'
import { useContentQuery } from '../hooks/useContentQuery'
import { StripeProcessing } from '../components/StripeProcessing'

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export type CheckoutProps = {
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const Checkout: FC<CheckoutProps> = ({
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages, votesCount, votes, activeLanguage, price, currency } =
    useAppCtx()
  const { data: navDictionary = {} } = useTranslations('navigation')
  const { data: sequence = {} } = useContentQuery('sequence')
  const { data: dictionary = {} } = useTranslations('checkout')

  const { data: publishableKeys } = useQuery('payment-stripe-pubkey')
  const { colors } = useTheme()
  const isMobile = useIsMobile()
  const [, setLocation] = useLocation()

  const [email, setEmail] = useState('')
  const [showTermsModal, setShowTermsModal] = useState(false)
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false)

  const hexColorForStripe = rgbaToHex(colors.primaryAccent)

  useEffect(() => {
    if (!votesCount || sequence?.sequenceType !== 'voting') {
      setLocation('/', { replace: true })
    }
  }, [votesCount, sequence, sequence?.sequenceType])

  if (
    !publishableKeys?.stripePublishableKey ||
    !price ||
    !currency ||
    !votesCount
  ) {
    return null
  }

  return (
    <Layout
      style={{
        padding: '32px 24px 96px',
        margin: '0 auto',
        justifyContent: 'start',
        maxWidth: 720,
        alignSelf: isMobile ? 'center' : undefined,
        gap: 16,
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label={ariaLabelProp.nav}
          isCartVisible
          isExpandable
          cartItems={votesCount}
          languages={languages}
        />
      </Layout.Navbar>

      <Layout.Top>
        <div style={{ marginBottom: 24 }}>
          <Link href="/cart">
            <button className="i j k"
            >
              <Text variant="display-medium" color={colors.primaryAccent}>
                ← {navDictionary.back_button}
              </Text>
            </button>
          </Link>
          <Text color="gradient" variant="title" isMultiline>
            {dictionary.checkout_title || 'Checkout'}
          </Text>
        </div>
      </Layout.Top>

      <Layout.Middle>
        {showTermsModal && <TermsModal setShowTermsModal={setShowTermsModal} />}
        <Payment
          stripePublishableKey={publishableKeys.stripePublishableKey}
          // @ts-ignore It falls back to english if it doesn't recognize it
          locale={activeLanguage}
          amount={price * votesCount}
          currency={currency}
          metadata={{
            votes: votes,
            // @ts-ignore
            editionId: window.DATA?.edition,
          }}
          appearance={{
            variables: {
              colorPrimary: hexColorForStripe,
              colorText: colors.primaryAccent,
              colorDanger: colors.error,
              fontFamily:
                'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              borderRadius: '0px',
              gridRowSpacing: '16px',
            },
            rules: {
              '.AccordionItem': {
                borderColor: 'transparent',
                boxShadow: 'none',
                padding: '4px',
                fontSize: '16px',
                backgroundColor: colors.background,
              },
              '.Input': {
                borderColor: colors.border,
                backgroundColor: colors.background,
                color: colors.textPrimary,
                borderRadius: '12px',
                height: '40px',
                fontSize: '14px',
              },
              '.Label': {
                marginBottom: '6px',
                color: colors.textSecondary,
                fontSize: '14px',
              },
            },
          }}
          postConfirmationTokenCheck={async ({
            cardGeo,
            confirmationTokenId,
            setErrorMessage,
          }) => {
            // INFO: this check happens in the frontend before
            // process payment is requested
            if (!cardGeo) {
              setErrorMessage(
                `${ErrorUserMessages.CantConfirmCardCountry}::0101`,
              )
              return false
            }

            return true
          }}
        >
          <CheckoutForm
            email={email}
            setEmail={setEmail}
            votes={votes}
            disabled={true}
            acceptedTerms={acceptedTerms}
            setAcceptedTerms={setAcceptedTerms}
            setShowTermsModal={setShowTermsModal}
          />
        </Payment>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label={ariaLabelProp.footer}
          languages={languages}
        />
      </Layout.Footer>
    </Layout>
  )
}

const CheckoutForm = ({
  email,
  setEmail,
  acceptedTerms,
  setAcceptedTerms,
  disabled,
  setShowTermsModal,
}: {
  email: string
  setEmail: (email: string) => void
  votes: Record<number, number>
  disabled: boolean
  acceptedTerms?: boolean
  setAcceptedTerms?: (x: boolean) => void
  setShowTermsModal?: ((x: boolean) => void) | undefined
}) => {
  const {
    complete,
    submitPayment,
    isProcessing,
    isWaiting,
    isDelayed,
    success,
    error,
  } = usePayment()
  const { colors } = useTheme()
  const [turnstileToken, setTurnstileToken] = useState<string | null>(null)
  const { votes, setVotes, votesCount, activeLanguage, price, currency } =
    useAppCtx()

  const [, setLocation] = useLocation()

  const [emailError, setEmailError] = useState<boolean>(false)

  const { data: dictionary = {} } = useTranslations('checkout')
  const { data: navDictionary = {} } = useTranslations('navigation')

  const inputOutlineColor = colors.primaryAccent.replace(/[\d.]+\)$/, '0.3)')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const requestPaymentFunctionPayload: RequestPaymentFunctionPayload = {
      captchaToken: turnstileToken,
      metadata: {
        votes,
        // @ts-ignore
        editionId: window.DATA?.edition,
      },
    }
    submitPayment({
      email,
      requestPaymentFunctionPayload,
    })
  }

  useEffect(() => {
    if (error) console.error(error)
  }, [error])

  useEffect(() => {
    if (success) {
      const voteKeys = Object.keys(votes).join('-')
      setLocation(`/thank-you/${voteKeys}`, { replace: true })
    }
  }, [success, votes])

  if (!price || !currency) {
    return null
  }

  const indexOfTermsLink = dictionary?.terms_checkbox.indexOf(
    navDictionary?.terms_and_conditions_title,
  )
  const endIndexOfTermsLink =
    indexOfTermsLink + navDictionary?.terms_and_conditions_title?.length

  let firstPart = dictionary?.terms_checkbox.substring(0, indexOfTermsLink)
  let lastPart = dictionary?.terms_checkbox.substring(endIndexOfTermsLink)

  return (
    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
      <Text
        variant="subheading-bold"
        style={{ marginBottom: 20, color: colors.textPrimary }}
      >
        {dictionary?.payment_method_heading}
      </Text>
      <div className="a d l m n o"
        style={{
          backgroundColor: adjustColor(colors.background, 'lighten', 20),}}
      >
        <Icon variant="shield" color={colors.textPrimary} />
        <Text color={colors.textPrimary} isMultiline>
          {dictionary?.security_notice}
        </Text>
      </div>

      <PaymentElement />

      {error && (
        <div className="p a d q l f r s m"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 22.0246C11.7333 22.0246 11.4791 21.9746 11.2375 21.8746C10.9958 21.7746 10.775 21.6329 10.575 21.4496L2.54998 13.4246C2.36664 13.2246 2.22498 13.0038 2.12498 12.7621C2.02498 12.5204 1.97498 12.2663 1.97498 11.9996C1.97498 11.7329 2.02498 11.4746 2.12498 11.2246C2.22498 10.9746 2.36664 10.7579 2.54998 10.5746L10.575 2.54961C10.775 2.34961 10.9958 2.20378 11.2375 2.11211C11.4791 2.02044 11.7333 1.97461 12 1.97461C12.2666 1.97461 12.525 2.02044 12.775 2.11211C13.025 2.20378 13.2416 2.34961 13.425 2.54961L21.45 10.5746C21.65 10.7579 21.7958 10.9746 21.8875 11.2246C21.9791 11.4746 22.025 11.7329 22.025 11.9996C22.025 12.2663 21.9791 12.5204 21.8875 12.7621C21.7958 13.0038 21.65 13.2246 21.45 13.4246L13.425 21.4496C13.2416 21.6329 13.025 21.7746 12.775 21.8746C12.525 21.9746 12.2666 22.0246 12 22.0246ZM12 12.9996C12.2833 12.9996 12.5208 12.9038 12.7125 12.7121C12.9041 12.5204 13 12.2829 13 11.9996V7.99961C13 7.71628 12.9041 7.47878 12.7125 7.28711C12.5208 7.09544 12.2833 6.99961 12 6.99961C11.7166 6.99961 11.4791 7.09544 11.2875 7.28711C11.0958 7.47878 11 7.71628 11 7.99961V11.9996C11 12.2829 11.0958 12.5204 11.2875 12.7121C11.4791 12.9038 11.7166 12.9996 12 12.9996ZM12 15.9996C12.2833 15.9996 12.5208 15.9038 12.7125 15.7121C12.9041 15.5204 13 15.2829 13 14.9996C13 14.7163 12.9041 14.4788 12.7125 14.2871C12.5208 14.0954 12.2833 13.9996 12 13.9996C11.7166 13.9996 11.4791 14.0954 11.2875 14.2871C11.0958 14.4788 11 14.7163 11 14.9996C11 15.2829 11.0958 15.5204 11.2875 15.7121C11.4791 15.9038 11.7166 15.9996 12 15.9996Z" />
          </svg>
          <Text variant="display-medium" color="white">
            Error: {error}
          </Text>
        </div>
      )}

      <Text
        variant="subheading-bold"
        style={{ marginTop: 36, marginBottom: 20, color: colors.textPrimary }}
      >
        {dictionary?.contact_info_heading}
      </Text>

      <Text style={{ marginBottom: 6 }}>{dictionary?.email_field_title}</Text>
      <styled.input className="t u i v w f x"
        style={{
          color: colors.textPrimary,
          border: `1px solid ${emailError ? 'red' : colors.border}`,
          '&:focus': {
            border: `1px solid ${colors.primaryAccent}`,
            outline: `3px solid ${inputOutlineColor}`,
          },
          '&::placeholder': {
            color: '#77787e',
          },
        }}
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onBlur={(e) => {
          setEmailError(
            (email.length > 0 && !emailRegex.test(email)) ||
              email.endsWith('.'),
          )
        }}
        placeholder="example@domain.com"
        required
      />
      {emailError && (
        <p className="y z"
        >
          Invalid email
        </p>
      )}

      <Text
        variant="subheading-bold"
        style={{ marginBottom: 24, marginTop: 48, color: colors.textPrimary }}
      >
        {dictionary?.information_heading}
      </Text>
      <div className="a l a0">
        <Icon variant="info" color={colors.textPrimary} />
        <Text isMultiline color={colors.textSecondary}>
          {dictionary?.fee_notice}
        </Text>
      </div>
      <div className="a l">
        <Icon variant="info" color={colors.textPrimary} />
        <Text isMultiline color={colors.textSecondary}>
          {dictionary?.refund_notice}
        </Text>
      </div>

      <Text
        variant="subheading-bold"
        style={{ marginBottom: 24, marginTop: 48, color: colors.textPrimary }}
      >
        {dictionary?.terms_heading}
      </Text>
      <div className="a a1 a0 d"
      >
        <styled.input className="a2 a3 j a4 a5 a6 k a7 a8 a9"
          id="checkout-accept-terms"
          type="checkbox"
          style={{
            outline: `2px solid ${colors.textSecondary}`,
            '&:checked': {
              //   background: colors.primaryAccent,
              background: colors.background,
              outline: `2px solid ${colors.primaryAccent}`,
              borderRadius: '1px',
            },
            '&:checked::before': {
              content: `url('data:image/svg+xml;utf8,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.6 10.4L5.45 8.25C5.26667 8.06667 5.03333 7.975 4.75 7.975C4.46667 7.975 4.23333 8.06667 4.05 8.25C3.86667 8.43333 3.775 8.66667 3.775 8.95C3.775 9.23333 3.86667 9.46667 4.05 9.65L6.9 12.5C7.1 12.7 7.33333 12.8 7.6 12.8C7.86667 12.8 8.1 12.7 8.3 12.5L13.95 6.85C14.1333 6.66667 14.225 6.43333 14.225 6.15C14.225 5.86667 14.1333 5.63333 13.95 5.45C13.7667 5.26667 13.5333 5.175 13.25 5.175C12.9667 5.175 12.7333 5.26667 12.55 5.45L7.6 10.4ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2Z" fill="${encodeURIComponent(colors.primaryAccent)}"/></svg>')`,
              position: 'absolute',
              top: '-1px',
              left: '-1px',
            },
          }}
          checked={acceptedTerms}
          onChange={(e) => setAcceptedTerms?.(e.target.checked)}
        />
        <div className="k aa a a1"
          onClick={() => setAcceptedTerms?.(!acceptedTerms)}
        >
          <Text>{firstPart}</Text>
          <Text
            style={{ color: colors.primaryAccent }}
            onClick={(e) => {
              e.stopPropagation()
              setLocation(`/terms-and-conditions`, { replace: false })
            }}
          >
            {navDictionary?.terms_and_conditions_title}
          </Text>
          <Text>{lastPart}</Text>
        </div>
      </div>
      <Turnstile setTurnstileToken={setTurnstileToken} />

      <Button
        id="checkout-submit"
        type="submit"
        isDisabled={
          !complete ||
          isProcessing ||
          isWaiting ||
          isDelayed ||
          !email ||
          !emailRegex.test(email) ||
          email.endsWith('.') ||
          !acceptedTerms ||
          !turnstileToken
        }
        style={{ marginTop: 24 }}
      >
        <Text variant="display-medium" color={colors.background}>
          {capitalize(
            (isProcessing
              ? `${dictionary?.processing_payment}...`
              : dictionary?.pay_button) ?? '',
          )}
        </Text>
      </Button>

      {isWaiting || isDelayed || isProcessing ? (
        <StripeProcessing isWaiting={isWaiting} isProcessing={isProcessing} />
      ) : null}
    </form>
  )
}
